var slEventSend = function slEventSend(payload) {
  if (typeof window !== 'undefined') {
    var _window$SL, _window$SL$API;
    (_window$SL = window.SL) === null || _window$SL === void 0 ? void 0 : (_window$SL$API = _window$SL.API) === null || _window$SL$API === void 0 ? void 0 : _window$SL$API.call(_window$SL, 'event', payload);
  }
};
export var slLogin = function slLogin(user) {
  slEventSend({
    name: 'Login',
    properties: {
      eventType: 'login-v1',
      cuidType: 'ctn',
      cuid: user.login
    }
  });
};
export var slAddToCart = function slAddToCart(items) {
  var existedItems = mapShopItems(items);
  /* Убираем дополнительные товары, которые идут в комплекте к основному */
  var cleanedItems = items.filter(function (item) {
    return !(item.details.isSamplingItem && item.details.isSamplingItemActive);
  });
  var newItems = mapShopItems(cleanedItems.slice(-1));
  newItems.forEach(function (item, i) {
    slEventSend({
      name: 'Add to Cart',
      properties: {
        eventType: 'add-to-cart-v1',
        value: item.price * item.quantity,
        productId: item.id,
        quantity: item.quantity,
        cart: existedItems.map(function (existedItem) {
          return {
            productId: existedItem.id,
            quantity: existedItem.quantity,
            itemPrice: existedItem.price
          };
        })
      }
    });
    existedItems.push(newItems[i]);
  });
};
var mapShopItem = function mapShopItem(_ref) {
  var itemId = _ref.id,
    itemType = _ref.itemType,
    productName = _ref.productName,
    details = _ref.details,
    price = _ref.price,
    quantity = _ref.quantity;
  var id = (itemId === '0' ? null : itemId) || (details === null || details === void 0 ? void 0 : details.ctn);
  if (id) {
    if (itemType === 'ctn') {
      var region = (details === null || details === void 0 ? void 0 : details.regionId) || '';
      id = "".concat(productName).concat(region && '_').concat(region);
    } else if (itemType === 'tariff') {
      var _details$presets;
      var preset = (details === null || details === void 0 ? void 0 : (_details$presets = details.presets) === null || _details$presets === void 0 ? void 0 : _details$presets.id) || '';
      id = "".concat(itemId).concat(preset && '_').concat(preset);
    }
  }
  return {
    id: id,
    price: price,
    quantity: quantity,
    itemType: itemType
  };
};
var mapShopItems = function mapShopItems(items) {
  return items.reduce(function (acc, item) {
    var mappedItem = mapShopItem(item);
    if (mappedItem.id && mappedItem.price || mappedItem.itemType === 'ctn') {
      acc.push(mapShopItem(item));
    }
    return acc;
  }, []);
};